import { InputAdornment, TextField, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Header/Header.css";
import SearchIcon from "@mui/icons-material/Search";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useAuth } from "../../hooks/useAuth";
import { useMasterData } from "../../hooks/useMasterData";
import { useLoading } from "../../hooks/useLoader";
import Popover from "@mui/material/Popover";
import ApiServices from "../../services/ApiServices";
import {
  LOGOUT,
  MODULES_PERMISSION_API,
  MASTER_DATA,
} from "../../constants/api-constants";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import { usePageMode } from "../../hooks/usePageMode";
import { fetchImageAsBase64 } from "../../utilities/common";
import { useFormik } from "formik";
import { SETTING_KEYS } from "../../constants/common";
import PropTypes from "prop-types";

const Header = (props) => {
  const formik = useFormik({
    initialValues: {
      role: "0",
      internalRole: "0",
    },
    enableReinitialize: true,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();
  const auth = useAuth();
  const masterData = useMasterData();
  const { showLoader } = useLoading();
  const page = usePageMode();
  const user = auth.getCurrentUser();
  const currentRole = localStorage.getItem("roleName") || "";
  const currentUserId = auth.getCurrentUser()?.email;
  const [image, setImage] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const loadMasterData = async () => {
    try {
      showLoader(true);
      const response = await ApiServices.httpGet(MASTER_DATA);
      masterData.setMasterData(response);
      showLoader(false);
    } catch (e) {
      showLoader(false);
      toast.error("Internal server error");
    }
  };
  useEffect(() => {
    let res = masterData.masterDataValue;
    if (!res || Object.keys(res).length === 0) {
      loadMasterData();
    }

    if (auth.getBrandImage() !== "null" || !auth.getBrandImage()) {
      setImage(`data:image/jpeg;base64,${auth.getBrandImage()}`);
    }
  }, [auth.getBrandImage()]);
  /*istanbul ignore next */
  const profileViewRoute = async () => {
    if (auth.getRole() === 1 || auth.getRole() === 2) {
      history.push(`/users/${auth.getCurrentUser()?.userId}`);
    } else if (auth.getRole() === 3) {
      page.setBreadcrumbRootNode({
        title: props.routeData?.title,
        path: props.routeData?.listRoute,
      });
      history.push(
        "/distributor/" + auth.getCurrentUser()?.userId + "/basic-information",
      );
      page.setEditMode(false);
    } else if (auth.getRole() === 4) {
      page.setBreadcrumbRootNode({
        title: props.routeData?.title,
        path: props.routeData?.listRoute,
      });
      history.push(
        "/enterprisegroup/" +
          auth.getCurrentUser()?.userId +
          "/basic-information",
      );
      page.setEditMode(false);
    }
  };
  /*istanbul ignore next */
  const onNext = async (e) => {
    /*istanbul ignore next */
    let selectedRole = auth
      .getCurrentUser()
      ?.roles?.filter((el) => el.roleId === Number(e.target.value));
    const intRole =
      formik.values.role === "3" || formik.values.role === "4"
        ? formik.values.internalRole
        : 0;
    auth.setRole(selectedRole[0]);
    auth.setInternalRole(intRole);
    const getPermissions = await ApiServices.httpGet(MODULES_PERMISSION_API);
    if (
      getPermissions.responseStatus.code === 200 &&
      getPermissions.responseStatus.isSuccess
    ) {
      auth.setModules(getPermissions.result.modules);
      if (getPermissions.result.user.logoGcpFileUrl) {
        await fetchImageAsBase64(
          getPermissions.result.user.logoGcpFileUrl,
        ).then((data) => {
          auth.setBrandImage(data);
        });
      } else {
        auth.setBrandImage(getPermissions.result.user.logoGcpFileUrl);
      }
    }
    if (history?.location?.state?.from?.pathname) {
      history.push(history.location.state.from.pathname); // return url
    } else {
      history.push("/dashboard"); // Default landing page
    }
    window.location.reload();
  };
  /*istanbul ignore next */
  const logout = async () => {
    try {
      const response = await ApiServices.httpPost(LOGOUT, {
        isweb: true,
      });
      if (response.responseStatus?.isSuccess) {
        // Clear purchase filters before clearing all localStorage
        localStorage.removeItem("purchase_filters");
        localStorage.clear();
        toast.success(response.responseStatus?.description);
        // Clear the page content
        document.body.innerHTML = "";
        // Replace the current URL with a new one
        window.history.replaceState(null, null, window.location.href);
        localStorage.setItem(
          "SessionLogout",
          response.responseStatus?.description,
        );
        window.location.reload();
        window.location.href = "/login";
      } else {
        toast.success(response.responseStatus?.error);
      }
    } catch (e) {
      console.log("err");
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  let isNonProdEnv =
    masterData?.masterDataValue?.result?.settings?.find(
      (x) => x.key === SETTING_KEYS.Is_Test_Environment,
    )?.value || "false";
  return (
    <div className="notification-profile">
      {isNonProdEnv === "true" && (
        <div className="notification-text">
          <Typography className="testmessagecustext">
            You are in a TEST environment!
          </Typography>
        </div>
      )}
      <div className="global-search">
        <TextField
          className="search-text-field"
          type="text"
          placeholder="Search Everything..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <div className="search-icon-div">
                  <img src="/images/search-icon.png" alt="search icon" />
                </div>
              </InputAdornment>
            ),
          }}
        />
        <div className="expanded-search">
          <div className="cross-button">
            <CloseOutlinedIcon />
          </div>
          <div className="expanded-left">
            <img src="/images/na.png" alt="Not Avaiable" />
            <div>
              <h6>Couldn’t find a match.</h6>
              <p>Don’t be sad, let’s try again...</p>
            </div>
          </div>
          <div className="expanded-right">
            <div className="people-list">
              <SearchIcon /> <h5>People </h5>
              <ul>
                <li>
                  <Link to="#">Harvey Gill</Link>
                </li>
                <li>
                  <Link to="#">Tomas Crawford</Link>
                </li>
                <li>
                  <Link to="#">Angelina Hubbard</Link>
                </li>
                <li>
                  <Link to="#">Julie Mendez</Link>
                </li>
                <li>
                  <Link to="#">Afolabi David</Link>
                </li>
              </ul>
            </div>
            <div className="role-list">
              <SearchIcon /> <h5>Role </h5>
              <ul>
                <li>
                  <Link to="#">Admin</Link>
                </li>
                <li>
                  <Link to="#">Guest Users</Link>
                </li>
                <li>
                  <Link to="#">XyZ RnR</Link>
                </li>
              </ul>
            </div>
            <div className="tips-list">
              <TipsAndUpdatesOutlinedIcon /> <h5>Quick Tips </h5>
              <div className="tips-data">
                <h5>
                  <span>
                    <img src="/images/command.png" alt="command" />
                  </span>{" "}
                  or Ctrl + B
                </h5>
                <h5>
                  Use this keyboard shortcut to instantly search anything.
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="notification">
        <div className="logout-menus">
          <div className="user-role-custom">Logged in as {currentRole}</div>
        </div>
        <div className="profile-photo">
          {auth.getBrandImage() !== "null" || !auth.getBrandImage() ? (
            <input
              type="image"
              src={image}
              alt="brand logo"
              onClick={handleClick}
              className="profile profile--image"
              aria-label="Open profile menu"
              aria-haspopup="true"
              aria-expanded={open}
              aria-controls={id}
              data-testid="brand-logo"
              draggable={false}
              style={{
                marginTop: "7px",
                padding: "0",
                height: "30px",
                cursor: "pointer",
              }}
            />
          ) : (
            <button
              type="button"
              onClick={handleClick}
              className="profile profile--initials"
              aria-label="Open profile menu"
              aria-haspopup="true"
              aria-expanded={open}
              aria-controls={id}
              data-testid="profile-initials-button"
              style={{
                cursor: "pointer",
              }}
            >
              {`${user?.firstName?.[0]?.toUpperCase() ?? ""}${
                user?.lastName?.[0]?.toUpperCase() ?? ""
              }`}
            </button>
          )}

          <Popover
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
          >
            <div className="logout-menu log-out-popover">
              <ul>
                <div className="logout-menu">
                  <div className="role-info">{currentUserId}</div>
                </div>
                <li>
                  <Link
                    to="#"
                    onClick={async () => {
                      profileViewRoute();
                    }}
                  >
                    <img src="/images/User-1.png" alt="profile" />
                    <span>Profile</span>
                  </Link>
                </li>
                {auth.getCurrentUser()?.roles?.length > 1 && (
                  <li>
                    <Link to="#">
                      <img src="/images/Swith-1.png" alt="profile" />
                      <span>Switch Role</span>
                    </Link>
                    <select
                      onChange={(e) => {
                        onNext(e);
                      }}
                      className="select-user select-cus-roles"
                      aria-label="Default select example"
                      name="role"
                      id="role"
                    >
                      <option key={0} value={0} selected>
                        {currentRole ? currentRole : "Select Role"}
                      </option>
                      {auth.getCurrentUser()?.roles?.map((opt) => {
                        return opt.roleId !== auth.getRoleId() ? (
                          <option key={opt.roleId} value={opt.roleId}>
                            {opt.name}
                          </option>
                        ) : null;
                      })}
                    </select>
                  </li>
                )}
                <li role="none">
                  <button
                    type="button"
                    className="custom-logout-css logout-btn"
                    onClick={logout}
                    aria-label="Logout"
                    data-testid="logout-button"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: 0,
                    }}
                  >
                    <img
                      src="/images/Logout-1.png"
                      alt=""
                      aria-hidden="true"
                      style={{ marginRight: 6 }}
                    />
                    <span>Logout</span>
                  </button>
                </li>
              </ul>
            </div>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default Header;

Header.propTypes = {
  routeData: PropTypes.shape({
    title: PropTypes.string,
    listRoute: PropTypes.string,
  }),
};
